import { render, staticRenderFns } from "./checkReceBasicInfo.vue?vue&type=template&id=ae4fc708"
import script from "./checkReceBasicInfo.vue?vue&type=script&lang=js"
export * from "./checkReceBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./checkReceBasicInfo.vue?vue&type=style&index=0&id=ae4fc708&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports